<div class="widget-container">
  <!-- Giveaway Widget -->
  <!-- <button class="widget-button giveaway" (click)="openModal('Competition')">
    <div class="widget-content">
      <span class="widget-icon">🎁</span>
      <span class="widget-text">Giveaway</span>
    </div>
    <span class="widget-arrow">›</span>
  </button> -->

  <!-- Hours Widget -->
  <!-- <button class="widget-button" (click)="openModal('OpenHours')">
    <div class="widget-content">
      <span class="widget-icon">🎄</span>
      <span class="widget-text">Hours</span>
    </div>
    <span class="widget-arrow">›</span>
  </button> -->

  <!-- Festive Offer Widget -->
  <button class="widget-button festive" (click)="openModal('Festive')">
    <div class="widget-content">
      <span class="widget-icon"></span>
      <span class="widget-text">Request Quote</span>
    </div>
    <span class="widget-arrow">›</span>
  </button>
</div>

<app-custom-modal
  [isVisible]="showModalFestive"
  [title]="festiveFormTitle"
  [showMessage]="true"
  [btnSubmitTitle]="'Request Quote'"
  (close)="closeModal('Festive')"
></app-custom-modal>

<!-- <app-popup-festive-sale
  [isVisible]="isOpenHoursVisible"
  (close)="closeModal('OpenHours')"
>
</app-popup-festive-sale> -->
<!-- <app-custom-modal
  [isVisible]="showModalCompetition"
  [title]="competitionFormTitle"
  [showMessage]="false"
  [promotionForm]="competitionForm"
  [btnSubmitTitle]="'Enter The Giveaway'"
  [btnGoToTitle]="'See Details'"
  (close)="closeModal('Competition')"
  (formSubmit)="enterGiveAway()"
></app-custom-modal> -->
